import { getAppConfig } from 'State/store';

// Defaults
// NATWEB also uses this same cookie, so if changes are made need to coordinate with them
const DEFAULT_TOKEN_NAME = 'FOXKITAUTHN';
const COOKIE_DOMAIN_NATION_REGEX = /^\.((qa|staging|dev)-)?nation/;

export function getHostname() {
  return window?.location?.hostname || '';
}

export function getCookieName() {
  const host = typeof window !== 'undefined' ? window.location.host : 'localhost:8080';

  const { nodeEnv } = getAppConfig().defaultConfig;

  const isLocalEnv = nodeEnv === 'development';

  const cookieName = isLocalEnv && host === 'localhost:8080' ? 'FOXKITAUTHN-LEGACY' : 'FOXKITAUTHN';

  return cookieName;
}

export function getCookieDomain() {
  const cookieName = getCookieName();
  const defaultConfig = getAppConfig().defaultConfig;
  const cookieDomain = defaultConfig?.cookieDomain;

  const hostname = getHostname();

  let domain = cookieDomain;
  // if no domain specified in options
  if (!domain) {
    // add dot prefix to support subdomains for non-localhost hostname
    // if this is local, just return the hostname (presumably 'localhost') directly
    if (hostname.includes('local')) return hostname;
    domain = `.${hostname}`;
  }
  if (
    cookieName === DEFAULT_TOKEN_NAME &&
    !COOKIE_DOMAIN_NATION_REGEX.test(domain) &&
    COOKIE_DOMAIN_NATION_REGEX.test(`.${hostname}`)
  ) {
    domain = `.${hostname.split('.')[0]}${domain}`;
  }

  return domain;
}
